import { __decorate } from '../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $ } from '../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { classMap as o } from '../../../../node_modules/lit-html/directives/class-map.js';
import { throttle, closeCountrySelectorOnEscape } from '../../utilities/behavior-helpers/index.js';
import { isRTL } from '../../utilities/dom-helpers/index.js';
import '../../molecules/tabs/index.js';
import './countries-list.js';
import './country-link.js';
import css_248z from './country-selector.scss.js';
import { TabsOrientation } from '../../molecules/tabs/enums.js';

class CountrySelector extends s {
    constructor() {
        super(...arguments);
        this.rtl = false;
        this.goToHomePageText = 'Go to Homepage';
        this.tabsOrientation = TabsOrientation.HORIZONTAL;
        this.windowHeight = '100vh';
        this.nextRegionTabIndex = 0;
        this.nextCountryIndex = 0;
        this.regionCountry = 'region';
        this.currentRegionIndex = 0;
        this.currentCountryIndex = 0;
        this.previousRegionIndex = 0;
        this.previousCountryIndex = 0;
        this.currentRegionActive = 0;
        this.currentCountryActive = 0;
        this.countriesTabsActive = false;
        this.buttonsArray = [];
        this.handleWindowResizeBound = undefined;
        this.throttledSetWindowHeightVar = throttle(() => {
            this.setWindowHeightVar();
        }, 0);
    }
    connectedCallback() {
        super.connectedCallback();
        this.handleWindowResizeBound = this.handleWindowResize.bind(this);
        window.addEventListener('resize', this.handleWindowResizeBound);
    }
    disconnectedCallback() {
        window.removeEventListener('resize', this.handleWindowResizeBound);
        super.disconnectedCallback();
    }
    firstUpdated() {
        this.handleWindowResize();
        this.setWindowHeightVar();
        this.setupKeydownHandler();
    }
    setWindowHeightVar() {
        const height = window.innerHeight;
        this.windowHeight = `${height}px`;
        this.style.setProperty('--windowheight', this.windowHeight);
    }
    handleWindowResize() {
        const windowWidth = window.innerWidth;
        if (windowWidth <= 1023) {
            this.tabsOrientation = TabsOrientation.VERTICAL;
        }
        else {
            this.tabsOrientation = TabsOrientation.HORIZONTAL;
        }
        this.throttledSetWindowHeightVar();
    }
    setupKeydownHandler() {
        this.addEventListener('keydown', (event) => {
            const buttonsList = this.getButtonsList();
            switch (event.key) {
                case 'Tab':
                    event.preventDefault();
                    if (this.countriesTabsActive) {
                        this.handleCountryTabNavigation();
                    }
                    else {
                        this.handleRegionTabNavigation(buttonsList);
                    }
                    break;
                case 'Enter':
                    this.handleEnterKey();
                    break;
                case 'Escape':
                    this.handleEscapeKey();
                    break;
            }
        });
    }
    getButtonsList() {
        var _a, _b, _c, _d;
        return (_d = (_c = (_b = (_a = this.shadowRoot) === null || _a === void 0 ? void 0 : _a.querySelector('tabs-container')) === null || _b === void 0 ? void 0 : _b.shadowRoot) === null || _c === void 0 ? void 0 : _c.querySelector('.nav-list')) === null || _d === void 0 ? void 0 : _d.children;
    }
    handleRegionTabNavigation(buttonsList) {
        if (!buttonsList || buttonsList.length === 0)
            return;
        this.buttonsArray = Array.from(buttonsList).filter((el) => el instanceof HTMLButtonElement);
        const numberOfButtons = this.buttonsArray.length;
        this.updateIndices(numberOfButtons, true);
        this.currentRegionButton = this.buttonsArray[this.currentRegionIndex];
        this.currentRegionSpan = this.getSpanFromButton(buttonsList, this.currentRegionIndex);
        const previousRegionSpan = numberOfButtons <= 1
            ? undefined
            : this.getSpanFromButton(buttonsList, this.previousRegionIndex);
        this.applyFocusStyles(this.currentRegionSpan, previousRegionSpan);
        this.currentRegionActive = this.currentRegionIndex;
        this.currentRegionIndex += 1;
    }
    handleCountryTabNavigation() {
        const numberOfCountries = this.currentCountriesList.length;
        this.updateIndices(numberOfCountries, false);
        this.currentCountryLink = this.getLinkFromCountry(this.currentCountriesList, this.currentCountryIndex);
        const previousCountryLink = numberOfCountries <= 1
            ? undefined
            : this.getLinkFromCountry(this.currentCountriesList, this.previousCountryIndex);
        this.applyFocusStyles(this.currentCountryLink, previousCountryLink);
        this.currentCountryActive = this.currentCountryIndex;
        this.currentCountryIndex += 1;
    }
    handleEnterKey() {
        if (!this.countriesTabsActive) {
            this.countriesTabsActive = true;
            this.resetFocusStyles(this.currentRegionSpan);
            this.updateSelectedClass();
            this.currentRegionButton.focus();
            this.selectCurrentRegionTab();
            this.currentCountriesList = this.currentRegionTab.children[0].children;
            this.currentCountryIndex = 0;
        }
        else {
            const currentCountryUrl = this.currentCountryLink.getAttribute('href');
            if (currentCountryUrl) {
                window.location.assign(currentCountryUrl);
            }
        }
    }
    handleEscapeKey() {
        if (this.countriesTabsActive) {
            this.countriesTabsActive = false;
            this.resetFocusStyles(this.currentCountryLink);
            this.applyFocusStyles(this.currentRegionSpan);
        }
        else {
            closeCountrySelectorOnEscape(this.parentElement, true);
        }
    }
    updateIndices(numberOfItems, isRegion) {
        if (isRegion) {
            this.previousRegionIndex =
                this.currentRegionIndex === 0
                    ? numberOfItems - 1
                    : this.currentRegionIndex - 1;
            this.currentRegionIndex =
                this.currentRegionIndex >= numberOfItems ? 0 : this.currentRegionIndex;
        }
        else {
            this.previousCountryIndex =
                this.currentCountryIndex === 0
                    ? numberOfItems - 1
                    : this.currentCountryIndex - 1;
            this.currentCountryIndex =
                this.currentCountryIndex >= numberOfItems
                    ? 0
                    : this.currentCountryIndex;
        }
    }
    applyFocusStyles(currentElement, previousElement) {
        const elementToStyle = currentElement;
        elementToStyle.style.boxShadow =
            'rgb(255, 255, 255) 0px 0px 0px 4px, rgb(111, 37, 149) 0px 0px 0px 8px';
        elementToStyle.style.borderRadius = '4px';
        if (previousElement) {
            const previousElementToStyle = previousElement;
            previousElementToStyle.style.boxShadow = 'unset';
            previousElementToStyle.style.borderRadius = 'unset';
        }
    }
    resetFocusStyles(element) {
        const elementToReset = element;
        elementToReset.style.boxShadow = 'unset';
        elementToReset.style.borderRadius = 'unset';
    }
    updateSelectedClass() {
        this.buttonsArray.forEach(button => button.classList.remove('selected'));
        this.currentRegionButton.classList.add('selected');
    }
    selectCurrentRegionTab() {
        const countrySelector = Array.from(document.querySelectorAll('country-selector'));
        const regionTabs = Array.from(countrySelector[0].children);
        regionTabs.forEach(tab => tab.removeAttribute('selected'));
        this.currentRegionTab = regionTabs[this.currentRegionActive];
        this.currentRegionTab.setAttribute('selected', '');
    }
    getSpanFromButton(buttonsList, index) {
        return buttonsList[index].children[0];
    }
    getLinkFromCountry(countryList, index) {
        return countryList[index].children[1];
    }
    render() {
        const containerCLassMap = {
            rtl: this.rtl || isRTL(),
        };
        return $ `<div class="country-selector-container ${o(containerCLassMap)}"><div class="header-mobile"><a href="/" class="country-selector-home-link" aria-label="${this.goToHomePageText}"><slot name="logo"></slot></a></div><div class="desktop-image-container"><slot name="desktoplogo"></slot></div><tabs-container navListId="countrySelectorNavList" ?rtl="${this.rtl || isRTL()}" orientation="${this.tabsOrientation}" visibleScroll><slot name="region"></slot></tabs-container></div>`;
    }
}
CountrySelector.styles = css_248z;
__decorate([
    e({ type: Boolean })
], CountrySelector.prototype, "rtl", void 0);
__decorate([
    e()
], CountrySelector.prototype, "goToHomePageText", void 0);
__decorate([
    t()
], CountrySelector.prototype, "tabsOrientation", void 0);
__decorate([
    t()
], CountrySelector.prototype, "windowHeight", void 0);
__decorate([
    e({ type: Number })
], CountrySelector.prototype, "nextRegionTabIndex", void 0);
__decorate([
    e({ type: Number })
], CountrySelector.prototype, "nextCountryIndex", void 0);
__decorate([
    e()
], CountrySelector.prototype, "regionCountry", void 0);
customElements.define('country-selector', CountrySelector);

export { CountrySelector };
